import { useTranslation } from "react-i18next";
import { BreadcrumbJsonLd } from "@/src/common/components/breadcrumb-jsonld";
import { JsonLd } from "@/src/common/components/json-ld";
import { PageHelmet } from "@/src/common/components/page-helmet";
import { env } from "@/src/common/constants/env";
import { CtaSection } from "../components/sections/cta-section";
import { FaqSection } from "../components/sections/faq-section";
import { SiteShell } from "../components/site-shell";
import { getFaqItems } from "../constants/faq-items";
import { MARKETING_ROUTES } from "../constants/marketing-routes";

const FaqPage: React.FC = () => {
	const { t } = useTranslation("marketing");
	const pageUrl = `${env.SITE_URL}${MARKETING_ROUTES.FAQ}`;
	const faqItems = getFaqItems(t);

	return (
		<>
			<PageHelmet title={t("faq_page_title")} description={t("faq_page_description")} />
			<BreadcrumbJsonLd
				items={[
					{ name: t("breadcrumb_home"), url: env.SITE_URL },
					{ name: t("nav_faq_page"), url: pageUrl },
				]}
			/>
			<JsonLd
				data={{
					"@context": "https://schema.org",
					"@type": "FAQPage",
					mainEntity: faqItems.map((item) => ({
						"@type": "Question",
						name: item.question,
						acceptedAnswer: { "@type": "Answer", text: item.answer },
					})),
				}}
			/>
			<SiteShell>
				<main className="overflow-hidden">
					<div className="mx-auto max-w-7xl px-6 pb-24 pt-8 sm:px-8 lg:px-12">
						<header className="max-w-3xl py-12">
							<p className="text-sm font-semibold uppercase tracking-[0.24em] text-app-accent-secondary">{t("nav_faq_page")}</p>
							<h1 className="mt-4 text-4xl font-semibold tracking-[-0.06em] text-white sm:text-6xl">{t("faq_page_title")}</h1>
							<p className="mt-5 text-lg leading-8 text-white/70">{t("faq_page_intro")}</p>
						</header>
						<FaqSection items={faqItems} title={t("faq_page_title")} />
						<CtaSection />
					</div>
				</main>
			</SiteShell>
		</>
	);
};

export default FaqPage;
